import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

export default class TextInput extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    error: PropTypes.bool
  }

  static defaultProps = {
    error: false
  }

  hasValue = () => this.props.value && this.props.value !== ''

  render() {
    const { label, value, onChange, name, error, ...rest } = this.props;
    return (
      <div className={`text__input ${error ? 'text__input--error' : ''}`}>
        <input
          id={label}
          className="text__input__field type__input__field"
          value={value}
          onChange={onChange}
          name={name}
          {...rest} />
        {
          !this.hasValue() && (<label htmlFor={label} className="text__input__label type__input__label">{label}</label>)
        }
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/TextInput/TextInput.js